import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-slide-hot-news-event',
  templateUrl: './slide-hot-news-event.component.html',
  styleUrls: ['./slide-hot-news-event.component.scss']
})
export class SlideHotNewsEventComponent implements OnInit {
@Input() data;
@Input() id_slide;

  constructor() { }

  ngOnInit(): void {
  }

  date = [
    {
      time: '30/5/2020',
      view: '750'
    },
    {
      time: '18/5/2020',
      view: '9029'
    },
    {
      time: '12/5/2020',
      view: '15k'
    },
  ]

}
